import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('medicare_advantage_benefits_set',
  '/medicare_advantage_benefits_sets',
  'benefits_set')
const actions = generator.generate()

export default actions
